import ConversationType from 'owa-service/lib/contract/ConversationType';
import getTombstonedReasons from 'mini-mail-list-tombstone/lib/utils/getTombstonedReasons';
import isMiniFeatureEnabled from 'owa-mini-feature-flags/lib/isMiniFeatureEnabled';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import TombstoneReasonType from 'mini-mail-list-tombstone/lib/store/schema/TombstoneReasonType';
import { getConversationOrItemIdFromRow } from 'mini-mail-list-table-operations/lib/utils/getConversationOrItemIdFromRow';
import { getLastModifiedTime } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { MailListRowDataType } from 'mini-mail-list-store/lib/store/schema/MailListRowDataType';

/**
 * This determines whether the server payload should be consumed and
 * if client properties need to be synced
 * @param row row payload from server
 * @param tableView to which the row belongs
 * @returns a flag indicating whether the row should be processed further or not
 */
const shouldProcessServerPayload = (row: MailListRowDataType, tableView: TableView): boolean =>
    !shouldSkipProcessRow(row as ConversationType, tableView);

export default shouldProcessServerPayload;

function isConversationView(tableView: TableView) {
    return tableView.tableQuery.listViewType === ReactListViewType.Conversation;
}

export function shouldSkipProcessRow(row: MailListRowDataType, tableView: TableView): boolean {
    // Do not process the row if it was earlier than the lastEmptiedTime in case we did an empty folder in this tableView
    const rowLastModifiedTime = getLastModifiedTime(getConversationOrItemIdFromRow(row), tableView);

    if (tableView.lastEmptiedTime && tableView.lastEmptiedTime > new Date(rowLastModifiedTime)) {
        return true;
    }

    const shouldProcessForTombstone = isConversationView(tableView);
    if (isMiniFeatureEnabled('mini-markAsJunkMultiSelect') && shouldProcessForTombstone) {
        /**
         * Conversation is in tombstoned for remove reason so do not process it further
         */
        const tombstoneReasons = getTombstonedReasons(row.InstanceKey, tableView.serverFolderId);

        if (tombstoneReasons.indexOf(TombstoneReasonType.RowRemove) > -1) {
            return true;
        }
    }

    return false;
}
